import React from 'react';
import ArticleSearchContainer from '../../../containers/ArticleSearchContainer'

const Loader = () => {
  const { isSearching } = ArticleSearchContainer.useContainer();
  return (
    <>
      {isSearching && 
        <div className='m_loaderZone isLoader' role='status' aria-live='polite'>
          <div className="ball-pulse"><div></div><div></div><div></div></div>
          <div className='loadingText'>検索中</div>
        </div>
      }
      <div id='jsResultShower' className='m_loaderZone isShowNum' role='status' aria-live='polite' style={{display: 'none'}}>
        <span id='jsResultShowerNum' className='resultNum'></span>件見つかりました。
      </div>
    </>
  );
};

export default Loader;